import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
} from 'admin-on-rest'
import { YearMonthFilters } from './Filters'
// import NumberLinkField from '../NumberLinkField'

const rowStyle = (record, index) => ({
	fontWeight: record.is_total ? 'bold' : 'normal',
	backgroundColor: record.is_total ? '#fafafa' : '',
});

export const AccountsReceivableRelease = (props) => (
    <List {...props}
		title="Monthly Accounts Receivable Based on Release"
		filters={<YearMonthFilters />}
		actions={<ListActions refreshInterval="900000" />}
		sort={{ field: 'dealership', order: 'ASC' }}
		perPage={100}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid rowStyle={rowStyle}>
					<TextField source="dealership" label="Dealership" />
					<NumberField source="transmitted_proceeds_num" label="Num" sortable={false}/>
					<NumberField source="transmitted_proceeds" label="Transmitted Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} to={`accounts/`} />
					<NumberField source="transmitted_di" label="Transmitted DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="review_proceeds_num" label="Num" sortable={false}/>
					<NumberField source="review_proceeds" label="Review Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} to={`accounts/`} />
					<NumberField source="review_di" label="Review DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="booked_proceeds_num" label="Num" sortable={false}/>
					<NumberField source="booked_proceeds" label="Booked Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<NumberField source="booked_di" label="Booked DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="for_collection_proceeds_num" label="Num" sortable={false}/>
					<NumberField source="for_collection_proceeds" label="For Collection Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<NumberField source="for_collection_di" label="For Collection Proceeds DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="for_di_num" label="Num" sortable={false}/>
					<NumberField source="for_di" label="For Collection DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/AccountsReceivableRelease.js